module.exports = __webpack_public_path__ + "img/manage-openings-icon.0499ba8f.svg";